// React-
import { useCallback } from "react";

// i18n-
import { useTranslation } from "react-i18next";

// Hook to change the language of the app
const useChangeLanguage = () => {
  const { i18n } = useTranslation();
  
  const changeLanguage = useCallback((newLanguage: string) => {
    i18n.changeLanguage(newLanguage);
    sessionStorage.setItem("appLanguage", newLanguage);
  }, []);

  return changeLanguage;
};

export default useChangeLanguage;
